/**
 * DefrostDeclaration - synchronized with the Prisma enum of the same name.
 * `FREEZING_TECH_REQUIRED` and `DEFROST_NO_IMPACT` are the two exception
 * paths that require a written `defrostExceptionNote` at the confirmation
 * gate — they are the cases where the "decongelato" badge does not simply
 * follow from `preparationKind` plus the `fromFrozen` rows.
 */
export const DEFROST_DECLARATIONS = [
  'NOT_FROZEN',
  'SOLD_DEFROSTED',
  'FROZEN_INGREDIENTS_ONLY',
  'FREEZING_TECH_REQUIRED',
  'DEFROST_NO_IMPACT',
] as const;
export type DefrostDeclaration = (typeof DEFROST_DECLARATIONS)[number];
